import { forwardRef } from 'react';
import styles from './StyleConstants.module.css';

const cx = (base: string, extra?: string) =>
  extra ? `${base} ${extra}` : base;

type HeadingProps = React.HTMLAttributes<HTMLHeadingElement>;
type ParagraphProps = React.HTMLAttributes<HTMLParagraphElement>;
type DivProps = React.HTMLAttributes<HTMLDivElement>;

export const H2 = forwardRef<HTMLHeadingElement, HeadingProps>(
  ({ className, ...props }, ref) => (
    <h2 ref={ref} className={cx(styles.h2, className)} {...props} />
  ),
);
H2.displayName = 'H2';

export const H2Md = forwardRef<HTMLHeadingElement, HeadingProps>(
  ({ className, ...props }, ref) => (
    <h2 ref={ref} className={cx(styles.h2Md, className)} {...props} />
  ),
);
H2Md.displayName = 'H2Md';

export const H2Custom = forwardRef<HTMLHeadingElement, HeadingProps>(
  ({ className, ...props }, ref) => (
    <h2 ref={ref} className={cx(styles.h2Custom, className)} {...props} />
  ),
);
H2Custom.displayName = 'H2Custom';

export const H2Small = forwardRef<HTMLHeadingElement, HeadingProps>(
  ({ className, ...props }, ref) => (
    <h2 ref={ref} className={cx(styles.h2Small, className)} {...props} />
  ),
);
H2Small.displayName = 'H2Small';

export const P = forwardRef<HTMLParagraphElement, ParagraphProps>(
  ({ className, ...props }, ref) => (
    <p ref={ref} className={cx(styles.p, className)} {...props} />
  ),
);
P.displayName = 'P';

export const PSmall = forwardRef<HTMLParagraphElement, ParagraphProps>(
  ({ className, ...props }, ref) => (
    <p ref={ref} className={cx(styles.pSmall, className)} {...props} />
  ),
);
PSmall.displayName = 'PSmall';

export const PLarge = forwardRef<HTMLParagraphElement, ParagraphProps>(
  ({ className, ...props }, ref) => (
    <p ref={ref} className={cx(styles.pLarge, className)} {...props} />
  ),
);
PLarge.displayName = 'PLarge';

// Should be used only inside <Container>
export const LeftSideTextWrapper = forwardRef<HTMLDivElement, DivProps>(
  ({ className, ...props }, ref) => (
    <div
      ref={ref}
      className={cx(styles.leftSideTextWrapper, className)}
      {...props}
    />
  ),
);
LeftSideTextWrapper.displayName = 'LeftSideTextWrapper';
